<template>
  <div :class="{ 'quote-other-labour-licence-expired': $licenceExpired }">
    <div>
      <article class="box">
        <div class="columns is-gapless">
          <div class="column">
            <div class="columns is-gapless">
              <div class="column">
                <p class="title">Other Labour</p>
                <subtitle-totals :labels="['Other Labour Total', 'Grand Total']"
                  :totals="[otherTotal, innerValue.totalExGst]"
                  :shows="[true, true]" />
              </div>

            </div>

            <bulma-table class="table is-bordered is-striped is-narrow is-fullwidth"
              :columns="columns"
              :page-index="filter.pageIndex"
              :page-size="filter.pageSize"
              :total-rows="totalRows"
              :is-loading="isTableLoading"
              :sort-column="filter.sortColumn"
              :sort-order="filter.sortOrder"
              :draggable="true"
              :show-pagination="false"
              @pageChanged="onPageChange"
              @sort="sort">
              <draggable v-model="innerValue.others"
                :tag="'tbody'"
                v-bind="{'disabled': !isRowDraggable, chosen: 'chosen', ghostClass: 'draggable-ghost', dragClass: 'draggable-drag'}"
                @change="itemMoved"
                @end="endMove"
                handle=".item-drag-handle">
                <tr v-for="(item, index) in activeItems"
                  :key="item.quoteItemId"
                  :class="[defaultRowColourClass(item, getItemAssessments(item), false), rowDisplayStatus(item, getItemAssessments(item))]"
                  @click="highlightSelected(index, $event)"
                  :data-itemid="item.quoteItemId">
                  <td v-show="$userInfo.isSupportUser"
                    class="has-vertical-middle has-text-right linenumber-input">
                    <vue-numeric v-if="(!innerValue.readOnly && $userInfo.isSupportUser && !readOnlyView) && !isItemRemoved(item, getItemAssessments(item))"
                      class="input has-text-right"
                      :class="defaultRowColourClass(item, getItemAssessments(item), false)"
                      v-model.number="item.lineNumber"
                      :disabled="$licenceExpired"
                      :precision="0"
                      separator="" />
                    <span v-else>{{ item.lineNumber }}</span>
                  </td>
                  <td class="has-vertical-middle itemno-input">
                    <input v-if="(!item.deleteOtherItem && !innerValue.readOnly && !readOnlyView && !audanetLock) && !isItemRemoved(item, getItemAssessments(item))"
                      class="input"
                      :class="[defaultRowColourClass(item, getItemAssessments(item), false), !isValidItemNo(item.quoteItemId) ? 'is-danger': '']"
                      placeholder="Item No."
                      v-model="item.itemNo"
                      :disabled="$licenceExpired">
                    <span v-else>{{ item.itemNo }}</span>
                  </td>
                  <td class="has-vertical-middle itemdesc-input">
                    <input v-if="(!item.deleteOtherItem && !innerValue.readOnly && !readOnlyView && !audanetLock) && !isItemRemoved(item, getItemAssessments(item))"
                      class="input"
                      :class="[defaultRowColourClass(item, getItemAssessments(item), false), !isValidItemDesc(item.quoteItemId) ? 'is-danger': '']"
                      placeholder="Item Description"
                      v-model="item.itemDesc"
                      :disabled="$licenceExpired">
                    <span v-else>{{ item.itemDesc }}</span>
                    <div v-if="item.itemComment"
                      class="help is-primary">
                      <span class="has-text-weight-bold">Comment: </span>
                      <span>{{ item.itemComment }}</span>
                    </div>
                  </td>
                  <td class="has-vertical-middle has-text-centered">
                    <div v-if="(!item.deleteOtherItem && !innerValue.readOnly && !readOnlyView && !audanetLock) && !isItemRemoved(item, getItemAssessments(item))"
                      class="pretty p-icon p-curve p-smooth m-0 p-bigger">
                      <input v-model="item.reportOnly"
                        :disabled="!canMakeReportOnly(item) || $licenceExpired"
                        type="checkbox">
                      <div class="state p-primary">
                        <i class="icon mdi mdi-check" />
                        <label />
                      </div>
                    </div>
                    <span v-else
                      class="icon has-text-info">
                      <i class="mdi mdi-24px"
                        :class="[ item.reportOnly ? 'mdi-check' : '' ]" />
                    </span>
                  </td>
                  <td v-if="innerValue.quotingMethod === quotingMethodTypes.Hour"
                    class="has-vertical-middle has-text-right money-input"
                    :class="[{ 'tooltip' : isItemInvoiced(item) === true}]"
                    data-tooltip="Item rate is already invoiced!">
                    <vue-numeric v-if="(!innerValue.readOnly && !readOnlyView && !audanetLock) && !isItemRemoved(item, getItemAssessments(item)) && !isItemInvoiced(item)"
                      class="input has-text-right"
                      :class="[ defaultRowColourClass(item, getItemAssessments(item), false), item.rate !== findLabourRate(item.itemType, innerValue.rates, innerValue.shopRate).rate ? 'is-warning' : '' ]"
                      v-model.number="item.rate"
                      :disabled="$licenceExpired"
                      :precision="2"
                      @value-changed="updateValue(index, item)" />
                    <span v-else>{{ $filters.formatNumber(item.rate, $userInfo.locale) }}</span>
                  </td>
                  <td class="has-vertical-middle has-text-right money-input">
                    <vue-numeric v-if="(!innerValue.readOnly && !readOnlyView && !audanetLock) && !isItemRemoved(item, getItemAssessments(item))"
                      class="input has-text-right"
                      :class="defaultRowColourClass(item, getItemAssessments(item), false)"
                      v-model.number="item.hourValue"
                      :disabled="$licenceExpired"
                      :minus="innerValue.subQuoteNo !== 0"
                      :precision="2"
                      @input="updateValue(index, item)" />
                    <span v-else>{{ $filters.formatNumber(item.hourValue, $userInfo.locale) }}</span>
                  </td>
                  <td class="has-vertical-middle has-text-right">
                    <div>{{ $filters.formatNumber(item.dollarValue, $userInfo.locale) }}</div>
                  </td>
                  <td class="has-vertical-middle">{{ item.itemType }}</td>
                  <td class="has-vertical-middle has-text-centered">
                    <div v-if="item.presentAs">
                      <div v-for="split in item.presentAs"
                        :key="split.itemType">
                        <div class="tags has-addons mb-0 present-as-tags">
                          <span :class="`tag mb-1 is-${split.itemType.toLowerCase()}`">{{ split.itemType }}</span>
                          <span class="tag is-dark mb-1">{{ split.percent }}%</span>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td v-show="$userInfo.isSupportUser"
                    class="has-vertical-middle itemstatus-input">
                    <input v-if="!innerValue.readOnly && !readOnlyView && !isItemRemoved(item, getItemAssessments(item))"
                      class="input is-capitalized"
                      v-model="item.itemStatus"
                      :disabled="$licenceExpired">
                    <span v-else>{{ item.itemStatus }}</span>
                  </td>
                  <td class="has-vertical-middle has-text-centered is-content-width">
                    <div class="icon-container items-center">
                      <supplementary-icon v-if="innerValue.quoteAssessments.length > 0"
                        :item="item"
                        :item-assessments="getItemAssessments(item)"
                        :next-assessment-number="nextSupplemetryNo"
                        :quoting-method="innerValue.quotingMethod"
                        :icon-size="4"
                        class="icon" />
                      <button v-if="!audanetLock && !isItemRemoved(item, getItemAssessments(item)) && (item.isDeleted === false || item.deleted === false)"
                        class="button is-danger is-small is-inverted tooltip is-tooltip-left"
                        @click="deleteItem(item, index)"
                        :disabled="innerValue.readOnly || readOnlyView || isItemRemoved(item, getItemAssessments(item)) || $licenceExpired"
                        :data-tooltip="$licenceExpired ? 'Disabled, as your licence has expired' : 'Delete'">
                        <span class="icon is-small">
                          <i class="mdi mdi-delete mdi-24px" />
                        </span>
                      </button>
                      <button class="button has-background-primary-45 is-small is-inverted tooltip"
                        @click="showPresentAsModal(item, index)"
                        :disabled="isItemRemoved(item, getItemAssessments(item)) || $licenceExpired"
                        :data-tooltip="$licenceExpired ? 'Disabled, as your licence has expired' : 'Present As'">
                        <span class="icon is-small">
                          <i class="mdi mdi-format-page-split mdi-24px" />
                        </span>
                      </button>
                      <button class="button is-primary is-small is-inverted item-drag-handle pr-0 pl-1"
                        :class="{ 'tooltip is-tooltip-left': $licenceExpired }"
                        :data-tooltip="$licenceExpired ? 'Disabled, as your licence has expired' : null"
                        :disabled="innerValue.readOnly || readOnlyView || $licenceExpired">
                        <span class="icon is-small">
                          <i class="mdi mdi-drag-vertical mdi-24px" />
                        </span>
                      </button>
                    </div>
                  </td>
                </tr>
              </draggable>
              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <span icon="icon is-large">
                      <i class="mdi mdi-48px mdi-emoticon-sad" />
                    </span>
                    <p>Nothing</p>
                  </div>
                </section>
              </template>
              <template slot="footer">
                <tr>
                  <th class="has-text-right"
                    :colspan="totalColSpan">Mech</th>
                  <th class="has-text-right"
                    :class="{ 'has-text-danger' : mechTotal < 0 }">{{ $filters.formatCurrency(mechTotal, $userInfo.locale) }}</th>
                  <th colspan="100%" />
                </tr>
                <tr>
                  <th class="has-text-right"
                    :colspan="totalColSpan">CD</th>
                  <th class="has-text-right"
                    :class="{ 'has-text-danger' : cdTotal < 0 }">{{ $filters.formatCurrency(cdTotal, $userInfo.locale) }}</th>
                  <th colspan="100%" />
                </tr>
                <tr>
                  <th class="has-text-right"
                    :colspan="totalColSpan">Crush</th>
                  <th class="has-text-right"
                    :class="{ 'has-text-danger' : crushTotal < 0 }">{{ $filters.formatCurrency(crushTotal, $userInfo.locale) }}</th>
                  <th colspan="100%" />
                </tr>
                <tr>
                  <th class="has-text-right"
                    :colspan="totalColSpan">FG</th>
                  <th class="has-text-right"
                    :class="{ 'has-text-danger' : fgTotal < 0 }">{{ $filters.formatCurrency(fgTotal, $userInfo.locale) }}</th>
                  <th colspan="100%" />
                </tr>
                <tr>
                  <th class="has-text-right has-text-success"
                    :colspan="totalColSpan">Totals</th>
                  <th class="has-text-right has-text-success"
                    :class="[ otherTotal >= 0 ? 'has-text-success' : 'has-text-danger' ]">{{ $filters.formatCurrency(otherTotal, $userInfo.locale) }}</th>
                  <th colspan="100%" />
                </tr>
              </template>
            </bulma-table>
            <totals-floating-widget :active.sync="isFloatingWidgetActive"
              title="Other Labour Totals"
              :mech-total="mechTotal"
              :cd-total="cdTotal"
              :crush-total="crushTotal"
              :fg-total="fgTotal"
              :totals="otherTotal"
              :total-ex-gst="innerValue.totalExGst" />
          </div>
        </div>
      </article>
    </div>
    <quote-item-present-as-modal v-if="isPresentAsModalActive"
      :active.sync="isPresentAsModalActive"
      v-model="selectedItem.presentAs"
      @ok="closeModal()"
      @cancel="closeModal()"
      @close="closeModal()">
      <p slot="text-title">Present As</p>
    </quote-item-present-as-modal>
  </div>
</template>

<script>
import BulmaTable from '@/components/BulmaTable'
import { OtherLabourColumns } from './columns'
import { ItemCategoryTypes, QuotingMethodTypes, LabourTimeTypes, QuoteItemStatusTypes, EventHubTypes } from '@/enums'
// import _orderBy from 'lodash/orderBy'
import VueNumeric from '@/components/VueNumeric'
import { roundAwayFromZero } from '@/components/utils/AccountingFunctions'
import { TotalsFloatingWidget, SupplementaryIcon } from './components'
import _isEmpty from 'lodash/isEmpty'
import _cloneDeep from 'lodash/cloneDeep'
import { QuoteAssessmentMixin, QuoteItemValidationMixin, QuoteOtherLabourMixin } from './mixins'
import { QuoteItemModel } from '@/classes/viewmodels'
import draggable from 'vuedraggable'
import SubtitleTotals from '@/components/SubtitleTotals'
import { QuoteItemPresentAsModal } from '@/components/BulmaModal'

export default {
  name: 'QuoteOtherLabour',
  components: {
    BulmaTable,
    VueNumeric,
    TotalsFloatingWidget,

    SupplementaryIcon,
    SubtitleTotals,
    draggable,
    QuoteItemPresentAsModal
  },
  mixins: [QuoteItemValidationMixin, QuoteOtherLabourMixin, QuoteAssessmentMixin],
  props: {
    value: null,
    nextLineNumber: {
      type: Number,
      default: 0
    },
    vehicle: null,
    readOnlyView: {
      type: Boolean,
      default: false
    },
    audanetLock: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerValue: null,
      // items: null,
      selectedRow: null,
      // totalRows: 0,
      isTableLoading: false,
      filter: {
        sortColumn: OtherLabourColumns[1].name,
        sortOrder: OtherLabourColumns[1].defaultOrder,
        pageIndex: 1,
        pageSize: 100
      },
      isFloatingWidgetActive: true,
      isAvailableItemsActive: false,
      isAvailableItemsMainActive: false,
      addBlankDropdownActive: false,
      isPresentAsModalActive: false,
      selectedItem: null
    }
  },
  computed: {
    columns() {
      const c = _cloneDeep(OtherLabourColumns)
      if (this.value.quotingMethod === QuotingMethodTypes.Dollar) {
        c[5].title = 'Amount'
        c.splice(4, 1)
      } else if (this.value.quotingMethod === QuotingMethodTypes.Hour) {
        c[5].title = OtherLabourColumns[5].title
      }
      c[1].isVisible = this.$userInfo.isSupportUser
      c[c.length - 2].isVisible = this.$userInfo.isSupportUser
      return c
    },
    itemCategoryTypes() {
      return ItemCategoryTypes
    },
    activeItems() {
      return this.items
    },
    totalRows() {
      return this.activeItems.length
    },
    items() {
      if (this.innerValue) {
        return this.innerValue.others.filter((i) => i.itemType !== ItemCategoryTypes.MECH)
      }
    },
    isNtar() {
      return (
        this.innerValue.labourType === LabourTimeTypes.NTAR ||
        this.innerValue.labourType === LabourTimeTypes.LTAR ||
        this.innerValue.labourType === LabourTimeTypes.eMTA
      )
    },
    quotingMethodTypes() {
      return QuotingMethodTypes
    },
    totalColSpan() {
      return this.columns.length - (this.$userInfo.isSupportUser ? 6 : 7)
    },
    isRowDraggable() {
      return !this.innerValue.readOnly && !this.$licenceExpired
    },
    itemsAssessments() {
      return this.getOtherLabourItemsAssessments()
    },
    nextSupplemetryNo() {
      const nextSuppNo = Math.max(...this.value.quoteAssessments.map((i) => i.subQuoteNo)) + 1
      return nextSuppNo
    }
  },
  watch: {
    // value: {
    //   handler: function(newVal, oldVal) {
    //     this.innerValue = newVal
    //     this.filter.sortColumn = ''
    //     this.filter.sortOrder = ''
    //     // this.items = _orderBy(this.innerValue.others.filter(i => !i.deleted), [this.filter.sortColumn], [this.filter.sortOrder])
    //   },
    //   deep: true
    // },
    innerValue: {
      handler: function (newVal, oldVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  created() {
    this.innerValue = this.value
    // this.items = _orderBy(this.innerValue.others.filter(i => !i.deleted), [this.filter.sortColumn], [this.filter.sortOrder])
  },
  mounted() {
    this.$eventHub.$on(EventHubTypes.EntitySaved, () => {
      this.innerValue = this.value
    })
    this.$v.entity.others.$touch()
  },
  beforeDestroy() {
    this.$eventHub.$off(EventHubTypes.EntitySaved)
  },
  methods: {
    highlightSelected(index, event) {
      // this.selectedRow = index
    },
    onPageChange(pageIndex) {},
    sort(name, order) {
      this.filter.sortColumn = name
      this.filter.sortOrder = order
      // this.items = _orderBy(this.innerValue.others.filter(i => !i.deleted), [this.filter.sortColumn], [this.filter.sortOrder])
    },
    updateTotal() {
      this.isFloatingWidgetActive = true
    },
    deleteItem(item, index) {
      if (this.$licenceExpired) return
      let originalItemStatus = item.itemStatus
      if (item.isNew) {
        const itemIndex = this.innerValue.others
          .map(function (obj) {
            return obj.quoteItemId
          })
          .indexOf(item.quoteItemId)
        if (itemIndex >= 0) {
          this.innerValue.others.splice(itemIndex, 1)
          // this.items.splice(itemIndex, 1)
        }
      } else {
        item.deleted = true
        item.isDeleted = true
        item.itemStatus = QuoteItemStatusTypes.Deleted
        item.originalItemStatus = originalItemStatus
      }
      this.updateTotal()
      this.$toast.open({
        message: `Item <span class="is-italic">${item.itemDesc}</span> deleted`,
        type: 'is-danger',
        position: 'is-top',
        actionText: 'Undo',
        onAction: () => {
          if (item.isNew) {
            this.innerValue.others.splice(this.innerValue.others.length, 1, item)
            // this.items.splice(this.items.length, 1, item)
          } else {
            item.deleted = false
            item.isDeleted = false
            item.itemStatus = originalItemStatus
          }
          this.updateTotal()
        }
      })
    },
    restoreItem(item, index) {
      item.deleted = false
      item.isDeleted = false
      //TODO: must set item status to original item status
      this.updateTotal()
    },
    toggleAvailableItems() {
      this.isAvailableItemsMainActive = false
      this.isAvailableItemsActive = !this.isAvailableItemsActive
    },
    toggleAvailableItemsMain() {
      this.isAvailableItemsActive = false
      this.isAvailableItemsMainActive = !this.isAvailableItemsMainActive
    },
    onItemAdded(newItems) {
      this.filter.sortColumn = ''
      this.filter.sortOrder = ''
      if (!_isEmpty(newItems)) {
        const vm = this
        newItems.forEach(function (item) {
          vm.innerValue.others.splice(vm.innerValue.others.length, 1, item)
        })
        this.innerValue.lines = Math.max(...newItems.map((i) => i.lineNumber), 0) + 1
        // this.items = _orderBy(this.innerValue.others.filter(i => !i.deleted), [this.filter.sortColumn], [this.filter.sortOrder])
        this.$notification.success('', `Item${newItems.length > 1 ? 's' : ''} added`)
        // this.$toast.open({
        //   message: `Item${newItems.length > 1 ? 's' : ''} added`,
        //   type: 'is-success',
        //   position: 'is-bottom',
        //   queue: false
        // })
      }
    },
    toggleAddBlankMenu() {
      this.addBlankDropdownActive = !this.addBlankDropdownActive
    },
    generateItem(itemNo, description, hourValue, rate, type) {
      let newItem = new QuoteItemModel(this.innerValue.quoteId, itemNo, description, type)
      newItem.lineNumber = this.nextLineNumber
      newItem.itemNo = itemNo ? itemNo : this.$filters.pad(newItem.lineNumber, 4)
      newItem.hourValue = this.innerValue.quotingMethod === QuotingMethodTypes.Hour ? hourValue : roundAwayFromZero(hourValue * rate)
      newItem.rate = rate
      newItem.dollarValue = roundAwayFromZero(hourValue * rate)
      newItem.opgCode = this.vehicle.paintGroup
      newItem.sortNo = this.innerValue.others.length ? Math.max(...this.innerValue.others.map((i) => i.sortNo)) + 1 : 1
      return newItem
    },
    addBlankItem(type) {
      let hour = 0
      let rate = 0
      switch (type) {
        case ItemCategoryTypes.FIBER:
          rate = this.isNtar
            ? this.innerValue.shopRate
            : this.getLabourRate(ItemCategoryTypes.FIBER, this.innerValue.rates, this.innerValue.shopRate, this.innerValue.quoteId).rate
          break
        case ItemCategoryTypes.CRUSH:
          rate = this.isNtar
            ? this.innerValue.shopRate
            : this.getLabourRate(ItemCategoryTypes.CRUSH, this.innerValue.rates, this.innerValue.shopRate, this.innerValue.quoteId).rate
          break
        case ItemCategoryTypes.CD:
          rate = this.isNtar
            ? this.innerValue.shopRate
            : this.getLabourRate(ItemCategoryTypes.CD, this.innerValue.rates, this.innerValue.shopRate, this.innerValue.quoteId).rate
          break
        case ItemCategoryTypes.MECH:
          rate = this.isNtar
            ? this.innerValue.shopRate
            : this.getLabourRate(ItemCategoryTypes.MECH, this.innerValue.rates, this.innerValue.shopRate, this.innerValue.quoteId).rate
          break
      }
      const newItem = this.generateItem('', '', hour, rate, type)
      this.innerValue.others.splice(this.innerValue.others.length, 1, newItem)
      this.innerValue.lines = this.nextLineNumber + 1
      this.$notification.success('', 'Item added')
      // this.$toast.open({
      //   message: 'Item added',
      //   type: 'is-success',
      //   position: 'is-bottom',
      //   queue: false
      // })
    },
    itemMoved(event) {
      if (this.$licenceExpired) return
      // console.log(event.moved)
      let sortNo = Math.min(...this.innerValue.others.map((i) => i.sortNo))
      this.innerValue.others.forEach((item) => {
        item.sortNo = sortNo
        sortNo++
      })
    },
    endMove(event) {},
    closeModal() {
      this.isPresentAsModalActive = false
    },
    showPresentAsModal(item, index) {
      if (this.$licenceExpired) return
      this.selectedItem = item
      this.$nextTick(() => {
        this.isPresentAsModalActive = true
      })
    },
    getOtherLabourItemsAssessments() {
      return this.getItemsAssessments(this.items, this.innerValue.quoteAssessments)
    },
    getItemAssessments(item) {
      const itemAssessments = this.itemsAssessments.find((i) => i.quoteItemId === item.quoteItemId)
      if (itemAssessments) {
        return itemAssessments.assessments
      }
      return []
    },
    canMakeReportOnly(item) {
      const assessments = this.getItemAssessments(item)
      if (assessments.length > 0) {
        const lastAssessment = assessments[assessments.length - 1]
        const lastValues = lastAssessment[lastAssessment.length - 1]
        if (!lastValues.reportOnly) {
          return false
        }
      }
      return true
    }
  }
}
</script>

<style lang="scss">
.quote-other-labour-licence-expired {
  td:has(> input:disabled),
  .pretty:has(> input:disabled) {
    position: relative;
    cursor: not-allowed;

    &:hover::before {
      content: 'Disabled, as your licence has expired';
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 30;
      padding: 0.4rem 0.8rem;
      border-radius: 4px;
      background: rgba(74, 74, 74, 0.9);
      color: #fff;
      font-size: 0.75rem;
      font-weight: normal;
      white-space: nowrap;
      pointer-events: none;
    }
  }

  td > input:disabled {
    cursor: not-allowed;
  }
}
</style>

<style lang="scss" scoped>
.linenumber-input {
  width: 60px;
}
.itemno-input {
  max-width: 2.5em;
}
.itemdesc-input {
  min-width: 20em;
}
.money-input {
  max-width: 6.5em;
}
tfoot {
  tr {
    th {
      &:not(:last-child) {
        border-right: none;
      }
    }
  }
  tr:not(:last-child) {
    th {
      border-top: none;
      border-bottom: none;
    }
  }
}
.itemstatus-input {
  width: 50px;
}
.item-type-tag {
  width: 52px;
}
.present-as-tags {
  display: inline-flex;
  .tag {
    font-size: 0.6rem !important;
  }
}
</style>
